import React from "react";
import "./MoreProject.css";
import Fade from "react-reveal/Fade";
import dental from "../images/dental.png";
import rider from "../images/rider.png";
import weather from "../images/weathe.png";
import timer from "../images/pomodoro.png";
import dinner from "../images/dinner.png";
import ven from "../images/ven.png";

const MoreProjects = () => {
  return (
    <div className="project more">
      <h2 className="font-heading py-5 text-center">
        <span className="about-title ">Projects</span>
      </h2>
      <div className="container mt-5 py-5">
        <div className="row">
          <hr className="line" />
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={rider} className="img-project" alt="" />
            </div>
          </Fade>

          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">Ride Booking website</h3>
              <p className="details-p">
                Simple ride-booking app with the firebase authentication system.
              </p>
              <div className="skills">
                <span>React JS</span>
                <span>Bootstrap</span>
                <span>Firebase</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/Ride-Booking-App"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://bd-rider-app.web.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Site</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
        <div className="row ">
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={dental} className="img-project" alt="" />
            </div>
          </Fade>
          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">Dental Care</h3>
              <p className="details-p">
                A MERN stack project of a complete hospital appointment system
                with 2 dashboards.
              </p>
              <div className="skills">
                <span>React JS</span>
                <span>Express JS</span>
                <span>Node JS</span>
                <span>MongoDB</span>
                <span>Bootstrap</span>
                <span>Heroku</span>
                <span>Firebase</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/dental-care"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://dental-care-d96fe.web.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Demo</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
        <div className="row">
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={weather} className="img-project" alt="" />
            </div>
          </Fade>
          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">Weather website</h3>
              <p className="details-p">Weather app with REST API.</p>
              <div className="skills">
                <span>React JS</span>
                <span>Bootstrap</span>
                <span>REST API</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/weather-app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://mariamchowdhury.github.io/weather-app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Site</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
        <div className="row">
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={timer} className="img-project" alt="" />
            </div>
          </Fade>
          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">Pomodoro Clock</h3>
              <p className="details-p">Pomodoro clock made with React.js</p>
              <div className="skills">
                <span>React JS</span>
                <span>Bootstrap</span>
                <span>Netlify</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/Pomodoro-clock-react"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://jovial-beaver-dba62d.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Site</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
        <div className="row">
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={dinner} className="img-project" alt="" />
            </div>
          </Fade>
          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">Dinner Tonight</h3>
              <p className="details-p">Website of a food searching system</p>
              <div className="skills">
                <span>React JS</span>
                <span>Bootstrap</span>
                <span>REST API</span>
                <span>Firebase</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/Dinner-Tonight"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://what-s-for-dinner-7383a.web.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Site</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
        <div className="row">
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={ven} className="img-project" alt="" />
            </div>
          </Fade>
          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">Venn diagram</h3>
              <p className="details-p">
                A small example of some basic mathematical operation with react
              </p>
              <div className="skills">
                <span>React JS</span>
                <span>Bootstrap</span>
                <span>Netlify</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/VennDiagram-with-React"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://laughing-fermi-b57a80.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Site</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
      </div>
    </div>
  );
};

export default MoreProjects;
